import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { REPORTING_DATASETS_READ } from 'automation-ui-enrollment/constants/Scopes';
const useHasDatasetsToolAccess = () => {
  return useHasScope(REPORTING_DATASETS_READ);
};
export default useHasDatasetsToolAccess;